<template>
    <div>
        <el-card>

            <div slot="header">
                <router-link :to="{ path:'/systemUserAdd', query:{callback: request,id:id,type:type}}">
                    <el-button type="primary" >添加人员</el-button>
                </router-link>

            </div>

        </el-card>

        <el-card>

            <el-table :data="tableData" border v-loading='loading'>

                <el-table-column type="index" width="50"></el-table-column>

                <el-table-column label="用户名 " prop="internalUserid"></el-table-column>

                <el-table-column label="真实姓名" prop="name"></el-table-column>

                <el-table-column label="所在部门" prop="departmentName"></el-table-column>

                <el-table-column label="操作" v-if='type === "group"'>
                    <template slot-scope='scope'>
                        <el-button class="table-del-btn" type="text" @click="deleteRole(scope.$index, tableData, scope.row.internalUserid, scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>


        <!--<el-card>-->

            <!--<el-dialog width="30%" title="添加人员" :visible.sync="innerVisible" append-to-body>-->
                <!--<systemUserAdd :id='id' :type='type' :callback='request' @closePopOut='closePopOut'/>-->
            <!--</el-dialog>-->

        <!--</el-card>-->
    </div>
</template>

<script>
import services from './system.services.js'
import systemUserAdd from './systemUserAdd'
export default {

    computed: {
        query() {
            return this.$route.query
        },
        id() {
            return +this.query.id
        },
        type() {
            return this.query.type
        },
        callback() {
            return this.query.callback
        }
    },

    components: {systemUserAdd},

    data() {
        return {
            loading: true,
            tableData: [],

        }
    },

    mounted() {
        this.request()
    },

    methods: {

        // 请求数据
        request() {
            if(this.type === 'group') {
                let params={
                    // ...this.form,
                    groupId:this.id
                }
                this.getuser(services.groupUser, params)
            } else {
                this.getuser(services.departmentUser, { departmentId: this.id })
            }
        },

        // 获取人员
        getuser(request, params) {
            request(params)
                .then(res => {
                    this.tableData = res.list
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // // 关闭弹框
        // closePopOut(info) {
        //     this.innerVisible = info;
        // },

        // 删除某一项
        deleteRole(index, rows, user, id) {
            this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    services.userGroupDelete({ groupId: this.id, internalUserid: [user] })
                        .then(res => {
                            rows.splice(index, 1);
                            this.$message.success('删除成功')
                        })
                }).catch(() => this.$messag.info('已取消删除'));
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
